module.exports = __webpack_public_path__ + "img/item-1-3.c0fd7963.png";